import dayjs from 'dayjs';

export function convertDateToString(dateObj: Date) {
  return dayjs(dateObj).format('YYYY-MM-DD');
}
